import { render, staticRenderFns } from "./CompletedPurchase.vue?vue&type=template&id=349858d7&"
import script from "./CompletedPurchase.vue?vue&type=script&lang=js&"
export * from "./CompletedPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports